var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sidebar-logo-container",
      class: { collapse: _vm.collapse },
      style: {
        backgroundColor:
          _vm.$store.state.settings.themeStyle === "dark"
            ? _vm.variables.menuBg
            : _vm.variables.menuLightBg,
      },
    },
    [
      _c(
        "transition",
        { attrs: { name: "sidebarLogoFade" } },
        [
          _vm.collapse
            ? _c(
                "router-link",
                {
                  key: "collapse",
                  staticClass: "sidebar-logo-link",
                  attrs: { to: "/" },
                },
                [
                  _vm.appInfo.logo
                    ? _c("img", {
                        staticClass: "sidebar-logo",
                        attrs: { src: _vm.appInfo.logo },
                      })
                    : _c(
                        "h1",
                        {
                          staticClass: "sidebar-title",
                          style: {
                            color:
                              _vm.$store.state.settings.themeStyle === "dark"
                                ? _vm.variables.sidebarTitle
                                : _vm.variables.sidebarLightTitle,
                          },
                        },
                        [_vm._v(_vm._s(_vm.appInfo.name) + " ")]
                      ),
                ]
              )
            : _c(
                "router-link",
                {
                  key: "expand",
                  staticClass: "sidebar-logo-link",
                  attrs: { to: "/" },
                },
                [
                  _vm.appInfo.logo
                    ? _c("img", {
                        staticClass: "sidebar-logo",
                        attrs: { src: _vm.appInfo.logo },
                      })
                    : _vm._e(),
                  _c(
                    "h1",
                    {
                      staticClass: "sidebar-title",
                      style: {
                        color:
                          _vm.$store.state.settings.themeStyle === "dark"
                            ? _vm.variables.sidebarTitle
                            : _vm.variables.sidebarLightTitle,
                      },
                    },
                    [_vm._v(_vm._s(_vm.appInfo.name) + " ")]
                  ),
                ]
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }